// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import BaseAddressesController from "./base_addresses_controller";
application.register("base-addresses", BaseAddressesController);

import BottomModalController from "./bottom_modal_controller";
application.register("bottom-modal", BottomModalController);

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import ClickController from "./click_controller";
application.register("click", ClickController);

import ClientFormController from "./client_form_controller";
application.register("client-form", ClientFormController);

import CreateCarController from "./create_car_controller";
application.register("create-car", CreateCarController);

import Detailing__AddressesController from "./detailing/addresses_controller";
application.register("detailing--addresses", Detailing__AddressesController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FlatpickrController from "./flatpickr_controller";
application.register("flatpickr", FlatpickrController);

import FormController from "./form_controller";
application.register("form", FormController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import Home__AddressesController from "./home/addresses_controller";
application.register("home--addresses", Home__AddressesController);

import KkmController from "./kkm_controller";
application.register("kkm", KkmController);

import MiniApp__AddressesController from "./mini_app/addresses_controller";
application.register("mini-app--addresses", MiniApp__AddressesController);

import MiniApp__AutoClickController from "./mini_app/auto_click_controller";
application.register("mini-app--auto-click", MiniApp__AutoClickController);

import MiniApp__BackButtonController from "./mini_app/back_button_controller";
application.register("mini-app--back-button", MiniApp__BackButtonController);

import MiniApp__TelegramController from "./mini_app/telegram_controller";
application.register("mini-app--telegram", MiniApp__TelegramController);

import MiniApp__TelegramFormController from "./mini_app/telegram_form_controller";
application.register(
  "mini-app--telegram-form",
  MiniApp__TelegramFormController,
);

import PellController from "./pell_controller";
application.register("pell", PellController);

import PinController from "./pin_controller";
application.register("pin", PinController);

import RatingController from "./rating_controller";
application.register("rating", RatingController);

import ReloadController from "./reload_controller";
application.register("reload", ReloadController);

import RemoveElementController from "./remove_element_controller";
application.register("remove-element", RemoveElementController);

import StopwatchController from "./stopwatch_controller";
application.register("stopwatch", StopwatchController);

import SuggestionsController from "./suggestions_controller";
application.register("suggestions", SuggestionsController);

import TabFilterController from "./tab_filter_controller";
application.register("tab-filter", TabFilterController);

import TimerController from "./timer_controller";
application.register("timer", TimerController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import ToggleVisibilityController from "./toggle_visibility_controller";
application.register("toggle-visibility", ToggleVisibilityController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);
